import { createGlobalStyle } from 'styled-components'
import { Colors } from '.'
import { fontFamily } from './typography'

const GlobalStyle = createGlobalStyle`
    :root {
       --animate-duration: 250ms !important;
       --animate-border-easing: 150ms ease-out !important;
    }
    html,
    body {
        height: 100%;
        margin: 0;
        padding: 0;
        /* Stop iOS Safari from inflating text in portrait; without this it silently overrides font sizes. */
        -webkit-text-size-adjust: 100%;
        /* Suppress the grey flash iOS paints over every tapped element. */
        -webkit-tap-highlight-color: transparent;
        /*
         * Drop double-tap-to-zoom. A task list is a wall of tap targets, and double-tap is what a
         * mistimed pair of taps on two neighbouring rows looks like — so the gesture fires far more
         * often by accident than on purpose, and each time it leaves the app magnified.
         *
         * "manipulation" still allows panning and pinch-zoom, which is the whole reason to reach for
         * it rather than a user-scalable=no viewport: deliberate zoom keeps working, the accidental
         * kind stops. Set on the root because a touch's effective touch-action is the intersection
         * down the ancestor chain, so one declaration here covers the document.
         */
        touch-action: manipulation;
        /*
         * Stop a scroll that runs off the end of a pane from rubber-banding the page behind it.
         * "contain" rather than "none": it blocks the chain, not the platform's own pull-to-refresh.
         */
        overscroll-behavior-y: contain;
        font-family: ${fontFamily.sans};
        -webkit-font-smoothing: antialiased;
        /* Counts, dates and times line up in columns instead of shifting width digit by digit. */
        font-variant-numeric: tabular-nums;
    }
    button,
    input,
    textarea {
        font-family: ${fontFamily.sans};
    }
    a {
        color: ${Colors.text.ink};
    }
    #event-details-popup {
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 100;
    }
    .__react_component_tooltip.show {
        opacity: 1 !important;
    }

`

export default GlobalStyle
